import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "LD Media — Marketing Bureau";
const DEFAULT_DESC =
  "LD Media er et dansk marketing bureau der hjælper virksomheder med organic marketing, Meta Ads, Google Ads, TikTok Ads, hjemmesider, SEO og content creation.";
const SITE_URL = "https://ldmedia.dk";
const OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_5e88ad15-a14f-4eb7-a874-cac507979086/artifacts/haj2wfbo_1000000444.jpg";

export const SEO = ({
  title,
  description = DEFAULT_DESC,
  path = "/",
  image = OG_IMAGE,
  type = "website",
  jsonLd,
}) => {
  const fullTitle = title ? `${title} — LD Media` : DEFAULT_TITLE;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content="LD Media" />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="LD Media" />
      <meta property="og:locale" content="da_DK" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd &&
        (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((data, i) => (
          <script key={i} type="application/ld+json">
            {JSON.stringify(data)}
          </script>
        ))}
    </Helmet>
  );
};
